import { Box, IconButton, Typography } from "@mui/material";
import LossCategoryCard, { LossType, UsinaDetail } from "./LossCategoryCard";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useContext, useState } from "react";
import { MainContext } from "../../../../main/context/MainContextProvider";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export type LossCategoryData = {
    title: string;
    type: LossType;
    eventos?: number;
    percentage: number;
    usinas: number;
    totalValue: string;
    valueSuffix?: string;
    usinaDetails: UsinaDetail[];
};

export type AnaliseCausaRaizDecomposicaoTableProps = {
    lossData: LossCategoryData[];
};

export default function AnaliseCausaRaizDecomposicaoTable({ lossData }: AnaliseCausaRaizDecomposicaoTableProps) {
    // Separa gerenciáveis e previstas
    const evitaveis = lossData.filter(data => data.type === LossType.EVITAVEL);
    const previstas = lossData.filter(data => data.type === LossType.PREVISTA);

    const { theme } = useContext(MainContext);

    const [previstaIsOpen, setPrevistaIsOpen] = useState(false);
    const [evitaveisIsOpen, setEvitaveisIsOpen] = useState(false);

    return (
        <Box>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: "8px", marginBottom: "12px" }}>
                <TrendingUpIcon sx={{ color: "#60A5FA", fontSize: 22 }} />
                <Typography sx={{ fontSize: "13px", fontWeight: "300", color: theme.secondaryTextColor }}>
                    Decomposição por Categoria
                </Typography>
            </Box>

            {/* Perdas Gerenciáveis */}
            {evitaveis.length > 0 && (
                <Box sx={{ marginY: "16px", borderBottom: "1px solid #515151", paddingBottom: "8px" }}>
                    <Box onClick={() => setEvitaveisIsOpen((prev) => !prev)} sx={{ cursor: "pointer", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingX: "12px" }}>
                        <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#f59e0b", marginBottom: "12px" }}>
                            Perdas Gerenciáveis
                        </Typography>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            sx={{ color: "#f59e0b" }}
                            onClick={() => {
                                setEvitaveisIsOpen((prev) => !prev);
                            }}
                        >
                            {evitaveisIsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </Box>
                    {evitaveisIsOpen && (
                        <Box>
                            {evitaveis.map((data, index) => (
                                <LossCategoryCard
                                    key={`evitavel-${index}`}
                                    title={data.title}
                                    type={data.type}
                                    eventos={data.eventos}
                                    percentage={data.percentage}
                                    usinas={data.usinas}
                                    totalValue={data.totalValue}
                                    usinaDetails={data.usinaDetails}
                                    valueSuffix={data.valueSuffix}
                                />
                            ))}
                        </Box>
                    )}
                </Box>
            )}

            {/* Perdas Previstas */}
            {previstas.length > 0 && (
                <Box sx={{ borderBottom: "1px solid #515151", paddingBottom: "8px" }}>
                    <Box onClick={() => setPrevistaIsOpen((prev) => !prev)} sx={{ cursor: "pointer", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingX: "12px" }}>
                        <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#3B82F6", marginBottom: "12px" }}>
                            Perdas Previstas (Inerentes ao Sistema)
                        </Typography>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            sx={{ color: "#3B82F6" }}
                            onClick={() => {
                                setPrevistaIsOpen((prev) => !prev);
                            }}
                        >
                            {previstaIsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </Box>
                    {previstaIsOpen && (
                        <Box>
                            {previstas.map((data, index) => (
                                <LossCategoryCard
                                    key={`prevista-${index}`}
                                    title={data.title}
                                    type={data.type}
                                    eventos={data.eventos}
                                    percentage={data.percentage}
                                    usinas={data.usinas}
                                    totalValue={data.totalValue}
                                    usinaDetails={data.usinaDetails}
                                    valueSuffix={data.valueSuffix}
                                />
                            ))}
                        </Box>
                    )}
                </Box>
            )}
        </Box>
    );
}
